import React from 'react';
import PropTypes from 'prop-types';
import GameProp from '../propTypes/gameProp';
import ChallengeListItem from './ChallengeListItem';
import ServerSideCarousel from '../../../commonComponents/carousel/ServerSideCarousel';
import ChallengePlaceholder from './ChallengePlaceholder';

export default function ChallengesSection({ title, games, type, carouselId }) {
  let url = '/challenges/unstarted';
  if (type) {
    url += `?gameType=${type}`;
  }

  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force">
      <div className="m-portlet__head">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title">
            <h3 className="m-portlet__head-text">{title}</h3>
          </div>
        </div>
      </div>
      <div className="m-portlet__body challenge-container">
        <ServerSideCarousel
          id={carouselId}
          fetchUrl={url}
          defaultFetchError="error_fetchChallenges"
          items={games}
          placeholder={<ChallengePlaceholder />}
        >
          {items => items.map(g => <ChallengeListItem game={g} key={g._id} />)}
        </ServerSideCarousel>
      </div>
    </div>
  );
}

ChallengesSection.propTypes = {
  carouselId: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  games: PropTypes.arrayOf(PropTypes.shape(GameProp.propType)).isRequired,
};

ChallengesSection.defaultProps = {
  carouselId: 'challenge-carousel',
  type: null,
};
